import colors from 'styles/colors'

const styles = {
  authTemplate: {
    childContainer: {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: 150
    }
  },
  header: {
    fontFamily: 'Barlow',
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '34px',
    textAlign: 'center',
    color: colors.lightGray
  },
  button: {
    button: {
      display: 'block',
      width: 290,
      margin: '0 auto',
      marginTop: 31
    }
  },
  guestText: {
    marginTop: 23,
    cursor: 'pointer',
    textAlign: 'center',
    fontFamily: 'Barlow',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.primary
  }
}

export default styles
